import { createAction } from '@reduxjs/toolkit';
import { AlertMessageProps } from '../schemas/app/alert-message';

export const addAlertMessage = createAction<AlertMessageProps>('ADD_ALERT_MESSAGE');
export const removeAlertMessage = createAction<number>('REMOVE_ALERT_MESSAGE');
